import { Box, Button, Typography, CircularProgress } from '@mui/material';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
import CommonModal from 'src/common/config/CommonModal';

function UpgradeNewPlanModal({
  showPricingModal,
  handleStayOnCurrentPlan,
  handleUpgrade,
  loading = false
}) {

  const descriptionArray = [
    {
      id: 1,
      title: "More value",
      desc: 'All plans now include AI Visibility, Local SEO and full SEO Audits - no feature left behind.',
      icon:
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clipPath="url(#clip0_25377_1369)">
            <path d="M15.3332 4L8.99984 10.3333L5.6665 7L0.666504 12M15.3332 8V4H11.3332" stroke="#120242" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
          </g>
          <defs>
            <clipPath id="clip0_25377_1369">
              <rect width="16" height="16" fill="white" />
            </clipPath>
          </defs>
        </svg>
    },
    {
      id: 2,
      title: "Better performance",
      desc: 'Faster, more reliable, and built for scale.',
      icon:
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M8.66667 1.33325L2 9.33325H8L7.33333 14.6666L14 6.66659H8L8.66667 1.33325Z" stroke="#120242" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    },
    {
      id: 3,
      title: "Ongoing support",
      desc: "We're here every step of the way. Expert plans also include a dedicated Slack channel.",
      icon:
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M13.3332 14V12.6667C13.3332 11.9594 13.0522 11.2811 12.5521 10.781C12.052 10.281 11.3737 10 10.6665 10H5.33317C4.62593 10 3.94765 10.281 3.44755 10.781C2.94746 11.2811 2.6665 11.9594 2.6665 12.6667V14M10.6665 4.66667C10.6665 6.13943 9.4726 7.33333 7.99984 7.33333C6.52708 7.33333 5.33317 6.13943 5.33317 4.66667C5.33317 3.19391 6.52708 2 7.99984 2C9.4726 2 10.6665 3.19391 10.6665 4.66667Z" stroke="#120242" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    }
  ]
  return (
    <CommonModal
      open={showPricingModal}
      title=""
      handCloseModal={() => { }}
      closebtn={false}
      isDynamicWidth="727px"
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          width: '100%',
          minHeight: '500px',
          backgroundColor: '#fff',
          position: 'relative',
          borderRadius: '8px',
          overflow: 'hidden'
        }}
      >
        <Box
          sx={{
            flex: '1',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            paddingX: '8px',
            paddingBottom: '24px',
            paddingTop: '12px'
          }}
        >
          <Typography
            sx={{
              fontFamily: 'Inter',
              fontSize: { xs: '20px', md: '24px' },
              fontWeight: 600,
              marginBottom: '2px',
              color: 'var(--color-text-primary)',
              textTransform: 'capitalize'
            }}
          >
            New pricing plans built for your success
          </Typography>
          <Typography
            sx={{
              fontFamily: 'Inter',
              fontSize: '14px',
              marginBottom: '20px',
              color: 'var(--color-text-secondary)',
              fontWeight: 400
            }}
          >
            Every plan now includes all features - AI Visibility, Local SEO and full SEO Audits.
          </Typography>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              gap: '16px',
              paddingX: '16px',
              paddingY: '8px'
            }}
          >
            {/* Top Left Content */}
            <Box
              sx={{
                flex: '0 0 40%',
                backgroundColor: '#F7F4FC',
                display: { xs: 'none', sm: 'flex' },
                alignItems: 'center',
                justifyContent: 'center',
                padding: '24px',
                position: 'relative',
                overflow: 'hidden',
                borderRadius: '8px'
              }}
            >
              {/* Background Circle */}
              <Box
                sx={{
                  position: 'absolute',
                  width: { xs: '190px', md: '220px' },
                  height: { xs: '190px', md: '220px' },
                  borderRadius: '50%',
                  backgroundColor: 'rgba(18, 2, 66, 0.05)',
                  zIndex: 0
                }}
              />
              {/* Card */}
              <Box
                sx={{
                  width: { xs: '150px', md: '180px' },
                  height: { xs: '200px', md: '240px' },
                  backgroundColor: '#fff',
                  borderRadius: '12px',
                  boxShadow: '0px 20px 40px rgba(0, 0, 0, 0.08)',
                  position: 'relative',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-between',
                  padding: '24px 20px',
                  zIndex: 1,
                  borderTop: '12px solid #120242'
                }}
              >
                {/* Dollar Icon */}
                <Box
                  sx={{
                    width: '48px',
                    height: '48px',
                    borderRadius: '50%',
                    backgroundColor: '#120242',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginBottom: '16px',
                    boxShadow: '0px 4px 12px rgba(18, 2, 66, 0.3)'
                  }}
                >
                  <Typography
                    sx={{
                      color: '#fff',
                      fontSize: '24px',
                      fontWeight: 'bold'
                    }}
                  >
                    $
                  </Typography>
                </Box>
                {/* Chart Area */}
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'flex-end',
                    gap: '8px',
                    height: '90px',
                    position: 'relative',
                    zIndex: 1
                  }}
                >
                  {/* Smooth Curve Line with Arrow */}
                  <Box
                    component="svg"
                    viewBox="0 0 180 100"
                    sx={{
                      position: 'absolute',
                      top: '-38px',
                      left: '-8px',
                      width: { xs: '150px', md: '190px' },
                      height: { xs: '100px', md: '120px' },
                      overflow: 'visible',
                      zIndex: 2
                    }}
                  >
                    <defs>
                      <marker
                        id="arrow"
                        markerWidth="12"
                        markerHeight="12"
                        refX="8"
                        refY="4"
                        orient="auto"
                      >
                        <path d="M1,0 L2,8 L9,4 z" fill="#120242" />
                      </marker>
                      {/* Gradient Line */}
                      <linearGradient
                        id="curveGradient"
                        x1="0%"
                        y1="0%"
                        x2="100%"
                        y2="0%"
                      >
                        <stop
                          offset="0%"
                          stopColor="#120242"
                          stopOpacity="0.5"
                        />
                        <stop
                          offset="100%"
                          stopColor="#120242"
                          stopOpacity="1"
                        />
                      </linearGradient>
                    </defs>
                    {/* Main Smooth Curve */}
                    <path
                      d="M 8 82 C 35 72, 45 62, 58 52 S 99 10, 120 -20"
                      fill="none"
                      stroke="url(#curveGradient)"
                      strokeWidth="4"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      markerEnd="url(#arrow)"
                      filter="drop-shadow(0px 3px 6px rgba(18,2,66,0.25))"
                    />
                  </Box>
                  {/* Bars */}
                  <Box
                    sx={{
                      width: '20%',
                      height: '30%',
                      backgroundColor: '#120242',
                      opacity: 0.3,
                      borderRadius: '4px'
                    }}
                  />
                  <Box
                    sx={{
                      width: '20%',
                      height: '50%',
                      backgroundColor: '#120242',
                      opacity: 0.5,
                      borderRadius: '4px'
                    }}
                  />
                  <Box
                    sx={{
                      width: '20%',
                      height: '70%',
                      backgroundColor: '#120242',
                      opacity: 0.7,
                      borderRadius: '4px'
                    }}
                  />
                  <Box
                    sx={{
                      width: '20%',
                      height: '100%',
                      backgroundColor: '#120242',
                      borderRadius: '4px'
                    }}
                  />
                </Box>
              </Box>
            </Box>
            {/* Top Right Content */}
            <Box>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '16px'
                }}
              >
                {descriptionArray?.map((item, index) => {
                  return (
                    <Box sx={{ display: 'flex', gap: '16px' }} key={index}>
                      <Box
                        sx={{
                          width: '56px',
                          height: '56px',
                          borderRadius: '8px',
                          backgroundColor: '#E7DFFF',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          flexShrink: 0
                        }}
                      >
                        <Box sx={{ width: '16px', height: '16px' }}>
                          {item?.icon}
                        </Box>
                      </Box>
                      <Box>
                        <Typography
                          sx={{
                            fontWeight: 700,
                            color: '#120242',
                            fontSize: '14px',
                            marginBottom: '2px'
                          }}
                        >
                          {item?.title}
                        </Typography>
                        <Typography
                          sx={{
                            color: '#5D5F6C',
                            fontSize: '14px',
                            fontWeight: 400
                          }}
                        >
                          {item?.desc}
                        </Typography>
                      </Box>
                    </Box>
                  )
                })}
              </Box>
            </Box>
          </Box>

          <Box
            sx={{
              display: 'flex',
              gap: '12px',
              alignItems: 'center',
              marginTop: '20px',
              paddingY: '15px',
              paddingX: '18px',
              borderRadius: '8px',
              border: '1px solid',
              backgroundColor: '#F7F4FC',
              borderColor: '#A8A6BF',
              marginX: '16px',
              marginBottom: '28px'
            }}
          >
            <Box sx={{ width: "16px", height: "16px", flexShrink: 0 }}>
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_25377_63266)">
                  <path d="M8.00016 10.6666V7.99992M8.00016 5.33325H8.00683M14.6668 7.99992C14.6668 11.6818 11.6821 14.6666 8.00016 14.6666C4.31826 14.6666 1.3335 11.6818 1.3335 7.99992C1.3335 4.31802 4.31826 1.33325 8.00016 1.33325C11.6821 1.33325 14.6668 4.31802 14.6668 7.99992Z" stroke="#120242" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
                </g>
                <defs>
                  <clipPath id="clip0_25377_63266">
                    <rect width="16" height="16" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </Box>
            <Typography
              sx={{
                color: 'var(--color-primary)',
                fontSize: '14px',
                fontWeight: 400
              }}
            >
              You can stay on your current plan with no changes. If you choose to stay, we won't show this message again.
            </Typography>
          </Box>
          <Box
            sx={{
              display: 'flex',
              gap: '16px'
            }}
          >
            <Box
              sx={{
                display: 'flex',
                flex: 1,
                flexDirection: 'column',
                alignContent: 'center'
              }}
            >
              <Button
                variant="outlined"
                onClick={handleStayOnCurrentPlan}
                disabled={loading}
                sx={{
                  flex: 1,
                  display: 'flex',
                  flexDirection: 'column',
                  padding: '12px',
                  borderRadius: '8px',
                  '&:hover': {
                    borderColor: 'var(--color-primary)',
                    backgroundColor: 'rgba(84, 52, 211, 0.04)'
                  }
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px'
                  }}
                >
                  {loading && <CircularProgress size={17} sx={{ color: 'var(--color-primary)' }} />}
                  <Typography
                    sx={{
                      fontWeight: 600,
                      fontSize: '15px',
                      color: 'var(--color-primary)'
                    }}
                  >
                    Stay on Current Plan
                  </Typography>
                </Box>
              </Button>
            </Box>
            <Box
              sx={{
                display: 'flex',
                flex: 1,
                flexDirection: 'column'
              }}
            >
              <Button
                variant="contained"
                onClick={loading ? null : handleUpgrade}
                sx={{
                  flex: 1,
                  display: 'flex',
                  flexDirection: 'column',
                  padding: '12px',
                  backgroundColor: 'var(--color-primary)',
                  textTransform: 'none',
                  borderRadius: '8px',
                  boxShadow: '0px 4px 10px rgba(84, 52, 211, 0.2)',
                  '&:hover': {
                    backgroundColor: 'var(--color-primary)', // To avoid issues with undefined dark variants
                    opacity: 0.9,
                    boxShadow: '0px 6px 14px rgba(84, 52, 211, 0.3)'
                  }
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px'
                  }}
                >
                  <Typography
                    sx={{
                      fontWeight: 600,
                      fontSize: '15px',
                      color: 'var(--color-white)'
                    }}
                  >
                    Upgrade
                  </Typography>
                  <RocketLaunchIcon sx={{ fontSize: '18px' }} />
                </Box>
              </Button>
            </Box>
          </Box>
        </Box>
      </Box>
    </CommonModal>
  );
}

export default UpgradeNewPlanModal;
